import api from "./api"
import { getStoredShipper } from "../constants/utils"
const EMAIL_NOTIFICATIONS_ROOT = "api/v1/config/config-type/"

const emailNotificationApi = {
    getAllEmails() {
        const { STORED_SHIPPER_ID, STORED_RAILROAD_ID } = getStoredShipper()
        return api.get(
            `${EMAIL_NOTIFICATIONS_ROOT}ORG?railRoad=${STORED_RAILROAD_ID}&shipper=${STORED_SHIPPER_ID}&appName=RVP`,
            "PLATFORM_SERVICE"
        )
    },
    createEmails(Emails) {
        const { STORED_SHIPPER_ID, STORED_RAILROAD_ID } = getStoredShipper()

        let cardata = {}
        if (Emails.car_orders_emails)
            cardata["car_orders"] = Emails.car_orders_emails
        else cardata["car_orders"] = ""
        if (Emails.car_actions_emails)
            cardata["car_actions"] = Emails.car_actions_emails
        else cardata["car_actions"] = ""
        if (Emails.general_placements_emails)
            cardata["general_placements"] = Emails.general_placements_emails
        else cardata["general_placements"] = ""
        if (Emails.switch_requests_emails)
            cardata["switch_requests"] = Emails.switch_requests_emails
        else cardata["switch_requests"] = ""

        return api.post(
            `${EMAIL_NOTIFICATIONS_ROOT}ORG`,
            {
                railRoad: STORED_RAILROAD_ID,
                shipper: STORED_SHIPPER_ID,
                appName: "RVP",
                configData: cardata,
            },
            "PLATFORM_SERVICE"
        )
    },
    updateEmails(Emails, configId) {
        const { SHIPPER } = getStoredShipper()

        let cardata = {}
        if (Emails.car_orders_emails)
            cardata["car_orders"] = Emails.car_orders_emails
        else cardata["car_orders"] = ""
        if (Emails.car_actions_emails)
            cardata["car_actions"] = Emails.car_actions_emails
        else cardata["car_actions"] = ""
        if (Emails.general_placements_emails)
            cardata["general_placements"] = Emails.general_placements_emails
        else cardata["general_placements"] = ""
        if (Emails.switch_requests_emails)
            cardata["switch_requests"] = Emails.switch_requests_emails
        else cardata["switch_requests"] = ""

        return api.put(
            `${EMAIL_NOTIFICATIONS_ROOT}ORG/config-id/${configId}`,
            {
                configData: cardata,
            },
            "PLATFORM_SERVICE"
        )
    },
}

export default emailNotificationApi
